import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import logoFooter from '../../assets/img/logo-footer.svg';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);

  const scrollUp = () => {
    document.addEventListener('click', (e) => {
      const { target } = e;

      if (!target.closest('.tabs-box') && !target.closest('#pills-tab') && !target.closest('.controls') && !target.closest('.pswp-gallery') && target.closest('a', 'button', '.main-map svg path', '.main-tab__button')) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  };

  useEffect(() => {
    scrollUp();
  }, [location]);

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-container">
          <div className="footer-logo">
            <div className="footer-logo__img">
              <img loading="lazy" src={logoFooter} alt="" />
            </div>
            <a
              className="footer-logo__link"
              href="/"
              onClick={(e) => {
                e.preventDefault();
                navigate('/');
              }}
            >
              <span>{dictionary.president_text_1}</span>
              <span>{dictionary.president_text_2}</span>
            </a>
          </div>

          <div className="footer-menu">
            <ul className="footer-menu__item">
              <li>{dictionary.menus.menu_1}</li>
              <li>
                <a
                  href="/president/power"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('president/power');
                  }}
                >
                  {dictionary.power}
                </a>
              </li>
              <li>
                <a
                  href="/president/symbols"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('president/symbols');
                  }}
                >
                  {dictionary.presidents_symbols}
                </a>
              </li>
              <li>
                <a
                  href="/president/biography"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('president/biography');
                  }}
                >
                  {dictionary.biography}
                </a>
              </li>
              <li>
                <a
                  href="/president/books"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('president/books');
                  }}
                >
                  {dictionary.books}
                </a>
              </li>
              <li>
                <a
                  href="/president/films"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('president/films');
                  }}
                >
                  {dictionary.films}
                </a>
              </li>
              <li>
                <a
                  href="/president/articles"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('president/articles');
                  }}
                >
                  {dictionary.articles}
                </a>
              </li>
              <li>
                <a
                  href="/president/awards"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('president/awards');
                  }}
                >
                  {dictionary.awards}
                </a>
              </li>
            </ul>
            <ul className="footer-menu__item">
              <li>{dictionary.government}</li>
              <li>
                <a
                  href="/government/head_of_government"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('government/head_of_government');
                  }}
                >
                  {dictionary.government_chief}
                </a>
              </li>
              <li>
                <a
                  href="/government/government_presidium"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('government/government_presidium');
                  }}
                >
                  {dictionary.government_presidium}
                </a>
              </li>
              <li>
                <a
                  href="/government/government_members"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('government/government_members');
                  }}
                >
                  {dictionary.government_members}
                </a>
              </li>
              <li>
                <a
                  href="/government/government_sessions"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('government/government_sessions');
                  }}
                >
                  {dictionary.government_assembly}
                </a>
              </li>
            </ul>
            <ul className="footer-menu__item">
              <li>{dictionary.executive}</li>
              <li>
                <a
                  href="/executive_office/chief_of_staff"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/executive_office/chief_of_staff');
                  }}
                >
                  {dictionary.strcuture_menu_level_6}
                </a>
              </li>
              <li>
                <a
                  href="/executive_office/regulations"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/executive_office/regulations');
                  }}
                >
                  {dictionary.strcuture_menu_level_10}
                </a>
              </li>
              <li>
                <a
                  href="/executive_office/structure"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/executive_office/structure');
                  }}
                >
                  {dictionary.strcuture_menu_level_11}
                </a>
              </li>
              <li>
                <a
                  href="/executive_office/assistants_to_the_president"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/executive_office/assistants_to_the_president');
                  }}
                >
                  {dictionary.strcuture_menu_level_7}
                </a>
              </li>
              <li>
                <a
                  href="/executive_office/press_service"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/executive_office/press_service');
                  }}
                >
                  {dictionary.strcuture_menu_level_9}
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-social">
            <div className="footer-social__title">
              <span>{dictionary.social_networks}</span>
            </div>

            <div className="footer-social__link">
              <a href="https://www.facebook.com/khadamotimatbuot">
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.9998 2.83594C9.17773 2.83594 2.83594 9.17773 2.83594 16.9998C2.83594 24.0682 8.01476 29.927 14.7872 30.9936V21.095H11.1892V16.9998H14.7872V13.8792C14.7872 10.3265 16.902 8.36747 20.136 8.36747C21.6856 8.36747 23.309 8.64369 23.309 8.64369V12.1269H21.5185C19.762 12.1269 19.2124 13.2205 19.2124 14.341V16.9969H23.1376L22.5101 21.0921H19.2124V30.9908C25.9848 29.9298 31.1636 24.0697 31.1636 16.9998C31.1636 9.17773 24.8218 2.83594 16.9998 2.83594Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="https://www.instagram.com/khadamotimatbuottjk/">
                <svg
                  width="35"
                  height="34"
                  viewBox="0 0 35 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="17.3337" cy="16.9983" r="14.1653" fill="white" />
                  <path
                    d="M25.7826 13.5087C25.7731 12.7935 25.6392 12.0853 25.387 11.416C25.1682 10.8514 24.8341 10.3387 24.4059 9.91054C23.9778 9.48241 23.4651 9.14828 22.9005 8.92952C22.2398 8.6815 21.5417 8.54738 20.8361 8.5329C19.9277 8.49229 19.6396 8.48096 17.3335 8.48096C15.0274 8.48096 14.7318 8.48096 13.83 8.5329C13.1247 8.54749 12.427 8.6816 11.7666 8.92952C11.2019 9.14813 10.6891 9.4822 10.2609 9.91036C9.83279 10.3385 9.49872 10.8513 9.28011 11.416C9.03159 12.0762 8.89776 12.7741 8.88443 13.4794C8.84382 14.3888 8.83154 14.6768 8.83154 16.9829C8.83154 19.2891 8.83154 19.5837 8.88443 20.4865C8.89859 21.1929 9.03175 21.8898 9.28011 22.5518C9.49908 23.1163 9.8334 23.6289 10.2617 24.0569C10.69 24.4848 11.2029 24.8188 11.7675 25.0373C12.4262 25.2953 13.124 25.439 13.8309 25.4623C14.7403 25.5029 15.0284 25.5152 17.3345 25.5152C19.6406 25.5152 19.9362 25.5152 20.838 25.4623C21.5436 25.4484 22.2417 25.3146 22.9024 25.0666C23.4668 24.8476 23.9794 24.5134 24.4075 24.0853C24.8356 23.6572 25.1698 23.1445 25.3888 22.5801C25.6372 21.9191 25.7704 21.2221 25.7845 20.5148C25.8251 19.6064 25.8374 19.3183 25.8374 17.0113C25.8355 14.7052 25.8355 14.4124 25.7826 13.5087ZM17.3279 21.344C14.916 21.344 12.9621 19.3901 12.9621 16.9782C12.9621 14.5664 14.916 12.6125 17.3279 12.6125C18.4857 12.6125 19.5962 13.0725 20.4149 13.8912C21.2336 14.7099 21.6936 15.8204 21.6936 16.9782C21.6936 18.1361 21.2336 19.2465 20.4149 20.0653C19.5962 20.884 18.4857 21.344 17.3279 21.344ZM21.8674 13.469C21.7336 13.4691 21.6012 13.4429 21.4776 13.3918C21.3541 13.3407 21.2418 13.2657 21.1472 13.1711C21.0527 13.0766 20.9777 12.9643 20.9266 12.8407C20.8755 12.7172 20.8492 12.5847 20.8494 12.451C20.8494 12.3174 20.8757 12.1851 20.9268 12.0616C20.9779 11.9382 21.0529 11.826 21.1474 11.7315C21.2419 11.637 21.354 11.5621 21.4775 11.5109C21.6009 11.4598 21.7333 11.4335 21.8669 11.4335C22.0005 11.4335 22.1328 11.4598 22.2563 11.5109C22.3797 11.5621 22.4919 11.637 22.5864 11.7315C22.6809 11.826 22.7558 11.9382 22.807 12.0616C22.8581 12.1851 22.8844 12.3174 22.8844 12.451C22.8844 13.0138 22.4293 13.469 21.8674 13.469Z"
                    fill="#3B6B3B"
                  />
                  <path
                    d="M17.3281 19.8143C18.8943 19.8143 20.164 18.5447 20.164 16.9785C20.164 15.4122 18.8943 14.1426 17.3281 14.1426C15.7619 14.1426 14.4922 15.4122 14.4922 16.9785C14.4922 18.5447 15.7619 19.8143 17.3281 19.8143Z"
                    fill="#3B6B3B"
                  />
                </svg>
              </a>
              <a href="https://t.me/khadamotimatbuotipresident">
                <svg
                  width="34"
                  height="34"
                  viewBox="-3 -3 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.165 0C6.37425 0 0 6.37425 0 14.165C0 21.9558 6.37425 28.33 14.165 28.33C21.9558 28.33 28.33 21.9558 28.33 14.165C28.33 6.37425 21.9558 0 14.165 0ZM21.1059 8.64065L18.6978 20.256C18.5562 21.1059 17.9896 21.2475 17.423 20.8226L13.7401 17.9896C12.8902 18.8395 12.0403 19.5477 11.8986 19.831C11.6153 19.9727 11.4736 20.256 11.1903 20.256C10.7654 20.256 10.7654 19.9727 10.6238 19.6894L9.3489 15.4399L5.52435 14.165C4.67445 13.8817 4.67445 13.3151 5.666 12.8902L20.1143 7.3658C20.6809 7.22415 21.3892 7.50745 21.1059 8.64065ZM17.7063 9.9155L9.6322 15.0149L10.9071 19.2644L11.1903 16.4314L18.1312 10.1988C18.5562 9.77385 18.2729 9.77385 17.7063 9.9155Z"
                    fill="white"
                  />
                </svg>
              </a>
              <a href="https://www.youtube.com/user/khadamotimatbuot">
                <svg
                  width="35"
                  height="34"
                  viewBox="0 0 35 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="17.6662" cy="16.9983" r="14.1653" fill="white" />
                  <path
                    d="M25.9695 12.8465C25.8709 12.4807 25.6782 12.1471 25.4106 11.8788C25.143 11.6106 24.8098 11.4172 24.4442 11.3178C23.0886 10.9455 17.6653 10.9395 17.6653 10.9395C17.6653 10.9395 12.2428 10.9334 10.8863 11.2892C10.5209 11.3932 10.1884 11.5894 9.92073 11.8589C9.65302 12.1284 9.45909 12.4623 9.35756 12.8283C9.00005 14.1839 8.99658 16.9956 8.99658 16.9956C8.99658 16.9956 8.99312 19.8211 9.34804 21.1628C9.54714 21.9047 10.1315 22.4908 10.8742 22.6907C12.2437 23.063 17.6523 23.069 17.6523 23.069C17.6523 23.069 23.0756 23.0751 24.4312 22.7202C24.7969 22.6209 25.1304 22.4279 25.3987 22.1602C25.667 21.8926 25.8607 21.5595 25.9608 21.194C26.3192 19.8393 26.3218 17.0285 26.3218 17.0285C26.3218 17.0285 26.3391 14.2021 25.9695 12.8465ZM15.9305 19.6003L15.9348 14.4064L20.4423 17.0077L15.9305 19.6003Z"
                    fill="#3B6B3B"
                  />
                </svg>
              </a>
              <a href="https://twitter.com/presstj">
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="17.0017" cy="16.9983" r="14.1653" fill="white" />
                  <path
                    d="M24.2098 13.2181C24.2221 13.3833 24.2221 13.5476 24.2221 13.7119C24.2221 18.7406 20.3947 24.5352 13.3999 24.5352C11.2449 24.5352 9.24283 23.9109 7.55811 22.8268C7.86408 22.8618 8.15871 22.874 8.47696 22.874C10.1891 22.8782 11.8527 22.3057 13.1997 21.2488C12.4059 21.2344 11.6364 20.9725 10.9986 20.4997C10.3608 20.0268 9.88667 19.3666 9.64229 18.6112C9.87743 18.6462 10.1135 18.6698 10.3609 18.6698C10.7018 18.6698 11.0446 18.6226 11.3629 18.5404C10.5014 18.3665 9.72678 17.8995 9.1707 17.219C8.61461 16.5384 8.31141 15.6863 8.31264 14.8074V14.7602C8.81976 15.0425 9.40809 15.2191 10.0314 15.2427C9.50922 14.8958 9.08108 14.425 8.78514 13.8723C8.4892 13.3196 8.33466 12.7023 8.33531 12.0754C8.33531 11.369 8.52323 10.7212 8.85281 10.1565C9.80862 11.3322 11.0007 12.2941 12.3519 12.9798C13.7032 13.6654 15.1833 14.0597 16.6966 14.1369C16.638 13.8536 16.6022 13.5599 16.6022 13.2653C16.6019 12.7657 16.7001 12.2709 16.8912 11.8093C17.0823 11.3477 17.3625 10.9283 17.7157 10.575C18.069 10.2217 18.4884 9.94154 18.95 9.75047C19.4117 9.5594 19.9064 9.46118 20.406 9.46143C21.5014 9.46143 22.4902 9.92038 23.1852 10.6626C24.0368 10.498 24.8535 10.1871 25.599 9.74379C25.3151 10.6228 24.7205 11.3682 23.9265 11.8402C24.6818 11.7541 25.42 11.5555 26.1165 11.251C25.5963 12.0094 24.9517 12.6744 24.2098 13.2181Z"
                    fill="#3B6B3B"
                  />
                </svg>
              </a>
              <a href="http://president.tj/rss-main">
                <svg
                  width="34"
                  height="34"
                  viewBox="0 0 34 34"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="17.0017" cy="16.9983" r="14.1653" fill="white" />
                  <path
                    transform="translate(6, 4)"
                    d="M16.1995 19C16.1995 12.8566 11.1434 7.80044 5 7.80044V5C12.679 5 19 11.321 19 19H16.1995ZM6.91844 15.1583C7.42823 15.1592 7.91688 15.3621 8.27736 15.7226C8.63783 16.0831 8.84076 16.5717 8.84168 17.0815C8.84168 18.139 7.97368 19 6.91406 19C5.85662 19 5 18.1408 5 17.0815C5 16.0224 5.86144 15.1583 6.91844 15.1583ZM14.2812 19H11.5582C11.5582 15.402 8.598 12.4397 5 12.4397V9.71888C10.0903 9.71888 14.2812 13.9092 14.2812 19Z"
                    fill="#3B6B3B"
                  />
                </svg>
              </a>
            </div>

            <div className="footer-social__service">
              <span>
                ©
                {' '}
                {dictionary.footer_info}
              </span>
              <span>
                {dictionary.phone_fax}
                :
                {' '}
                (+992 37) 221 25 20
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
